import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

/**
 * Wraps a route to make it accessible only to portal users with the
 * `super_user` role. Non-super users are redirected to the home page so the
 * Duplicate Accounts admin tool isn't reachable by mistake.
 *
 * Usage:
 *   <Route path="/foo" element={<AuthGuard><RequireSuperUser><Foo/></RequireSuperUser></AuthGuard>} />
 */
const RequireSuperUser = ({ children }) => {
  const auth = useSelector((state) => state.auth);
  if (auth?.role !== 'super_user') {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default RequireSuperUser;
